import React, { lazy, Suspense } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { ContentProvider } from "./contexts/ContentContext";
import HomePage from "./pages/HomePage";
import PracticeAreaPage from "./pages/PracticeAreaPage";
import PayPage from "./pages/PayPage";
import SiteLoader from "./components/SiteLoader";
import ScrollToTop from "./components/ScrollToTop";

const AdminApp = lazy(() => import("./admin/AdminApp"));

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <ScrollToTop />
        <Suspense fallback={<SiteLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/practice-areas/:slug" element={<PracticeAreaPage />} />
            <Route path="/pay" element={<PayPage />} />
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </Suspense>
        <Toaster />
      </ContentProvider>
    </div>
  );
}

export default App;
